import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IDonationFormButtonsProps extends IBaseElementProps {
	children?: any;
	disabled?: boolean;
	onChange?: (value: number) => void;
	value?: number;
	viewMode?: string;
}

const DonationFormButtons: React.FC<IDonationFormButtonsProps> = ({
	children,
	className,
	classNames = [],
	disabled = false,
	onChange,
	value,
	viewMode,
}) => {
	const button_amounts = [25, 50, 100, 200, 500];
	const [otherValue, setOtherValue] = useState(null);
	const handleButtonValue = (amount: number) => {
		if (onChange) {
			onChange(amount);
			setOtherValue(null);
		}
	};
	const handleOtherValue = (otherVal) => {
		if (onChange) {
			onChange(otherVal);
			setOtherValue(otherVal);
		}
	};

	useEffect(() => {
		if (button_amounts.indexOf(value) == -1) {
			setOtherValue(value);
		} else {
			setOtherValue('');
		}
	}, [value]);

	if ('miniMode' == viewMode) {
		return (
			<fieldset className="location-list__results-fieldset">
				<legend className="visually-hidden">Amount</legend>
				<div
					className="btn-group"
					role="group"
					aria-label="Donation Amounts"
				>
					{button_amounts.map((amount, index) => (
						<div className="location-list__radio">
							<button
								key={index}
								type="button"
								className={`btn ${
									amount === value ? 'active' : ''
								}`}
								disabled={disabled}
								onClick={() => {
									handleButtonValue(amount);
								}}
							>
								${amount}
							</button>
						</div>
					))}
				</div>
				<div className="input-group">
					<button className="btn" disabled={disabled}>
						Other
					</button>
					<input
						type="number"
						className="form-control"
						placeholder="0"
						aria-label="Amount (to the nearest dollar)"
						disabled={disabled}
						value={otherValue}
						onChange={(e) => {
							handleOtherValue(e.target.value);
						}}
					></input>
					<span
						className={`input-group-text ${
							disabled ? 'disabled' : ''
						}`}
					>
						CAD
					</span>
				</div>
			</fieldset>
		);
	} else {
		return (
			<>
				<div
					className="btn-group"
					role="group"
					aria-label="Donation Amounts"
				>
					{button_amounts.map((amount, index) => (
						<button
							key={index}
							type="button"
							className={`btn ${
								amount === value ? 'active' : ''
							}`}
							disabled={disabled}
							onClick={() => {
								handleButtonValue(amount);
							}}
						>
							${amount}
						</button>
					))}
				</div>
				<div className="input-group">
					<span className="btn">Other</span>
					<input
						type="number"
						className="form-control"
						placeholder="0"
						aria-label="Amount (to the nearest dollar)"
						disabled={disabled}
						value={otherValue}
						onChange={(e) => {
							handleOtherValue(e.target.value);
						}}
					></input>
					<span
						className={`input-group-text ${
							disabled ? 'disabled' : ''
						}`}
					>
						CAD
					</span>
				</div>
			</>
		);
	}
};

export default DonationFormButtons;
